import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function FormatQuote(props:any) {
  return (
    <SvgIcon {...props}>
      <path d="M7 7h4v4H7zM13 7h4v4h-4zM5 21h6v-6H5v6z" />
    </SvgIcon>
  )
}
